import React from 'react';

const BrandedLoader = ({
  title = 'Preparing your workspace',
  message = 'Advika is loading products, permissions, and shared context.',
}) => (
  <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#F8FAFC] px-6">
    <div className="absolute -left-20 top-16 h-72 w-72 rounded-full bg-[#F5F3FF] blur-3xl" />
    <div className="absolute -right-24 bottom-10 h-80 w-80 rounded-full bg-[#DDD6FE] opacity-70 blur-3xl" />
    <div className="relative flex w-full max-w-md flex-col items-center text-center">
      <div className="relative">
        <div className="absolute inset-0 animate-ping rounded-[28px] bg-[#6D5EF4]/20" />
        <div className="relative flex h-20 w-20 items-center justify-center rounded-[28px] bg-white shadow-[0_24px_70px_rgba(79,70,229,0.24)]">
          <img src="/advika-mark.png" alt="Advika" className="h-14 w-14 rounded-2xl" />
        </div>
      </div>
      <div className="mt-7 h-1.5 w-56 overflow-hidden rounded-full bg-[#E5E7EB]">
        <div className="h-full w-1/2 animate-[advika-loader_1.4s_ease-in-out_infinite] rounded-full bg-[linear-gradient(90deg,#312E81,#6D5EF4,#A78BFA)]" />
      </div>
      <p className="mt-6 text-xs font-semibold uppercase tracking-[0.28em] text-[#6D5EF4]">Advika OS</p>
      <h1 className="mt-3 text-2xl font-semibold tracking-tight text-slate-950">{title}</h1>
      <p className="mt-3 max-w-sm text-sm leading-6 text-slate-600">{message}</p>
    </div>
  </div>
);

export default BrandedLoader;
